// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.searchNumberType .el-form-item__label .el-select .el-input .el-input__inner,\n.searchNumberType .el-form-item__label .el-select .el-input .el-input__icon{\n  height: 28px;\n  line-height: 28px;\n  border: none;\n  padding: 0;\n}\n.searchNumberType .el-form-item__label .el-select .el-input .el-input__inner{\n  font-weight: bold;\n  font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
